import { useEffect, useState } from 'react';
import DashboardNavBar from './DashboardNavBar';
import DashboardNavBar2 from './DashboardNavBar2';

const PhoneView = ({onPostPhone}) => {
	
	var output;
	const [fullname, setFullName] = useState(localStorage.getItem('fullname'));
	const [verify, setVerify] = useState(localStorage.getItem('bankverify'));
	const [user, setUser] = useState(localStorage.getItem('useremail'));
	const [thisphone, setPhone] = useState(localStorage.getItem('phone'));
		
	useEffect(() => {
		document.getElementById('phonetab').style.color = '#23527C';
		document.getElementById('phonetab').style.fontWeight = '700';
		document.getElementById('phonetab').style.borderBottom = '1px solid #23527C';
		
		if(document.getElementById('phone'))
		{
			setPhone(thisphone);
			document.getElementById('phone').innerHTML = 'Registered Phone: '+thisphone;
			document.getElementById('phone').className="incsizespansms center";
		}
	},[thisphone]);
	
	const onSubmitPhone = (e) => {
		var phone, email, msg;
		phone = document.getElementById('phoneno').value;
		email = document.getElementById('loggedemail').value;
		
		setUser(user);
		setVerify(verify);
		setFullName(fullname);
		
		if(!phone){
			msg = 'Enter a valid phone number';
			document.getElementById('phonefeedback').innerHTML = msg;
			document.getElementById('phonefeedback').className = 'incsizespan_error center';
			return false;
		}
		

		output = {
			'phone': phone,
			'email': email,
			'rtype': 'phone',
			'key': localStorage.getItem('_key')
		};
		onPostPhone(output);
	}
	
	return [
	(
		<div className="container__canvas" style={rectStyleWrap} key="1"><div name="fadeStart" key="dv0" id="dv0"> <div className="tooltip"> <ul className="notification-list"> <li className="notification-item"> <div className="img-left"> <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet"> <g className="layer"> <g fill="#000000" id="svg_1" transform="translate(0, 160) scale(0.1, -0.1)"> <path d="m112.7258,1553.26096c-31.91754,-21.26496 -41.49282,-29.60415 -56.99562,-49.20126c-8.66333,-10.84096 -15.50281,-20.84799 -15.50281,-22.93279c0,-1.66784 -3.19175,-8.33919 -7.29544,-15.42752c-17.78263,-31.27199 -15.04685,-99.65339 5.47157,-139.26457c15.50281,-30.43806 60.64335,-70.88316 95.29667,-85.89371c24.16614,-10.424 76.60211,-20.43102 82.07369,-15.42752c0.91194,1.25089 -5.92754,6.67136 -15.95878,12.92575c-21.88632,13.34271 -36.4772,31.27199 -56.53966,69.21533c-20.97439,40.4451 -27.3579,75.88668 -24.16614,137.17977c2.27982,44.19773 8.66333,74.6358 21.43036,105.49083c7.29544,16.67838 -5.01561,18.34623 -27.81386,3.33568l0,0l0,0.00001l0.00001,-0.00001l0.00001,0z" id="svg_3"/> <path d="m239.48405,1540.33521c-11.39912,-10.424 -27.3579,-30.43806 -35.56527,-44.6147c-12.76702,-22.09887 -15.50281,-30.85502 -16.87071,-62.127c-1.82386,-30.0211 -0.91194,-37.10943 5.01561,-39.19422c10.48719,-3.33568 77.97001,33.77374 104.87194,58.37437c13.22299,11.67488 27.81386,28.35326 32.37351,36.69246l9.11929,15.42752l-24.62211,20.84799c-13.67895,11.67488 -28.26983,22.51582 -32.82948,23.76671c-4.55965,1.25089 -8.20737,4.1696 -8.20737,6.25439c0,8.75616 -14.13492,2.50175 -33.28544,-15.42752l0,0l0,-0.00001l0.00002,-0.00001l0.00001,0.00001z" id="svg_4"/> <path d="m366.69829,1456.52628c-9.57526,-26.26846 -87.08931,-81.30716 -135.42159,-95.48379c-12.31105,-3.75264 -23.71018,-8.33919 -25.07807,-10.424c-1.3679,-2.0848 5.47157,-17.09535 15.04685,-33.77374c17.78263,-31.27199 60.64335,-74.21884 73.86633,-74.21884c4.10368,0 17.78263,8.33919 30.09369,18.34623c52.89193,42.11294 75.23421,118.41658 52.89193,181.79448c-6.83947,19.59711 -8.20737,21.68191 -11.39912,13.75967l0,0l-0.00001,0l-0.00001,-0.00001z" id="svg_5"/> </g> </g> </svg> </div> <div className="user-content"> <p className="user-info"><span className="name">{fullname}</span></p> <p className="time">Status: {verify === '0' ? 'Unverified' : 'Verified'}</p> </div></li> </ul> </div></div><div className="Context"> {verify === '1' ? (<DashboardNavBar />) : (<DashboardNavBar2 />)} </div> </div>	
	),
	(<div className="[ stack ] [ container__controls ]" key="2">
		<input type="hidden" id="loggedemail" value={user || ''} />	
		<div className="container__control--switch">
			<button className="switch-btn">
				<span className="switch-btnn__marker" id="switch-btnn__marker"></span>
				<span className="center-xy switch-btn__label" ></span>
				<span className="center-xy switch-btn__label" id="4r1" >CONTACT</span>
				<span className="center-xy switch-btn__label" ></span>
			</button>
			
		</div>
	
		<div className="stack disshow" id="phonedisplay">
			<div style={center}>
				<h4 style={lineTwo} >UPDATE PHONE</h4>
			</div>
			
			<div className="incsizespan center" id="phone">
				
			</div>
			
			<div className="container__control--input">
				<input className="text-input" type="text" name="phoneno" id="phoneno" placeholder="New Phone Number" maxLength="14" />
			</div>
			
			
			<div className="incsizespan center" id="phonefeedback">
				
			</div>				
			<div className="container__buttons">
				<button className="clipboard" id="phoneproceed" onClick={onSubmitPhone}>PROCEED</button>
			</div>
		</div>			
	</div>)

	]
	
}

const lineTwo = {
   fontSize: '15px',
   color: '#23527c',
   lineHeight: '45px',
   fontWeight: '700'
}
const rectStyleWrap = {
   minWidth: '250px',
   gridColumn: 1
}
const center = {
   textAlign: 'center'   
}
export default PhoneView;